import React, { useEffect } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
// components
import Layout from "./Layout";
// pages
import Error from "../pages/error";
import Login from "../pages/login";
//App css import
import "../style/App.css";

// context
import RedirectTo from "../shared/redirect";
import ResetPassword from "../pages/resetPassword";
import UserActivate from "../pages/userActivate";

export default function App() {

  function isAuthenticated() {
    document.title = "Titan"
    if (localStorage.getItem("AUTH_TOKEN")) {
      return true;
    } else {
      return false;
    }
  }

  const storageChange = (event) => {
    // if (event.storageArea.length === 0) {
      if (event.key === null || event.key === "AUTH_TOKEN") {
        if (
          localStorage.getItem("AUTH_TOKEN") !== undefined ||
          localStorage.getItem("AUTH_TOKEN") !== null
        ) {
          window.location.reload();
        }
      }
    // }
  };

  useEffect(() => {
    window.addEventListener("storage", storageChange, false);
  }, []);

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        />
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/reset-password/:token" component={RedirectTo} />
        <PublicRoute path="/userActivate/:token" component={RedirectTo} />
        <PublicRoute path="/reset-password" component={ResetPassword} />
        <PublicRoute path="/user-activate" component={UserActivate} />

        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
